

// import RouterPage from './pages/FrontPage/RouterPage';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import "./App.css";
// import "./style/layout.css";


// function App() {
//     return (
//         <div className="main-container">
//       <RouterPage />
//       <ToastContainer position="top-center" autoClose={5000} />
//     </div>
//     );
// }

// export default App;





// import RouterPage from './pages/FrontPage/RouterPage';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './App.css';
// import './style/layout.css';  // if you still need it

// function App() {
//   return (
//     <div className="scale-wrapper">
//       <div className="main-container">
//         <RouterPage />
//         <ToastContainer />
//       </div>
//     </div>
//   );
// }

// export default App;


// App.js
import RouterPage from './pages/FrontPage/RouterPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';


function App() {
    
  return (
    
      <div >
        <RouterPage />
        <ToastContainer />
      </div>
    
  );
}

export default App;


// import RouterPage from './pages/FrontPage/RouterPage';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './App.css';
// import './style/layout.css';

// function App() {
//   return (
//     <div className="scale-wrapper">
//       <div className="main-container">
//         <RouterPage />
//         <ToastContainer />
//       </div>
//     </div>
//   );
// }

// export default App;


